const AVATAR_TONES = ['bg-[#ED5C2F]', 'bg-[#F28230]', 'bg-[#3F454F]']

const getInitials = (name = '') =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() || '')
        .join('')

const getRating = (review) => {
    const value = Number(review?.ratings)
    if (!Number.isFinite(value) || value <= 0) return 5
    return Math.min(5, Math.max(1, Math.round(value)))
}

function TestimonialCard({ review, tone }) {
    const name = review.client?.name || review.author || ''
    const role = review.client?.role || review.client?.title || ''
    const rating = getRating(review)

    return (
        <article className="rounded-[18px] border border-black/10 bg-white px-[26px] py-[28px] transition hover:-translate-y-[3px] hover:shadow-[0_16px_36px_-12px_rgba(63,69,79,0.10)]">
            <div
                className="mb-3 text-[13px] text-[#FAB331]"
                style={{ letterSpacing: '2px' }}
                aria-label={`${rating} out of 5 stars`}>
                {'★'.repeat(rating)}
                <span className="text-black/10">{'★'.repeat(5 - rating)}</span>
            </div>
            {review.text && (
                <p className="mb-5 text-[14.5px] leading-[1.65] text-[#4A5160]">
                    {review.text}
                </p>
            )}
            {name && (
                <div className="flex items-center gap-[11px]">
                    <div
                        className={`flex h-[38px] w-[38px] flex-shrink-0 items-center justify-center rounded-full text-[12.5px] font-extrabold text-white ${tone}`}>
                        {getInitials(name)}
                    </div>
                    <div>
                        <div className="text-[13.5px] font-extrabold text-[#3F454F]">
                            {name}
                        </div>
                        {role && (
                            <div className="mt-px text-[11.5px] font-medium text-[#6F7785]">
                                {role}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </article>
    )
}

function HomepageTestimonials({ reviews = [] }) {
    const reviewItems = Array.isArray(reviews)
        ? reviews
        : Array.isArray(reviews?.reviews)
        ? reviews.reviews
        : []

    const textReviews =
        reviewItems.length > 0
            ? reviewItems
                  .filter((review) => review.type === 'Text')
                  .sort(
                      (a, b) =>
                          String(a?.text || '').length -
                          String(b?.text || '').length,
                  )
                  .slice(0, 3)
            : []

    return (
        <section className="border-b border-black/10 bg-white py-14">
            <div className="container mx-auto px-5 md:px-0">
                <div className="text-[10px] font-semibold uppercase tracking-[0.08em] text-[#F28230]">
                    Customer results
                </div>
                <h2 className="mt-3 text-[clamp(26px,3.2vw,38px)] font-extrabold leading-[1.12] tracking-[-0.025em] text-[#3F454F]">
                    <span>Real programs. </span>
                    <span className="olm-gradient-text">
                        Measurable outcomes.
                    </span>
                </h2>

                <div className="mt-11 grid gap-4 md:grid-cols-3">
                    {textReviews.map((review, index) => (
                        <TestimonialCard
                            key={review.id || review.client?.name || index}
                            review={review}
                            tone={AVATAR_TONES[index % AVATAR_TONES.length]}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default HomepageTestimonials
